import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { RSMEmployeeDetailsReport } from './Pages';

export const RSMEmployeeDetailsReportRoutes = ({ match }) => (

    <Fragment>
        <Route exact path = {`${match.path}`} component={RSMEmployeeDetailsReport} />
    </Fragment>

)